import {useCallback, useContext} from 'preact/hooks';

import {Line, UiLineType} from 'layouts';
import {AppState} from 'utilities/app-state';
import {isMobileDevice} from 'utilities/dom';

import {ZipInputForm} from '../ZipInputForm';
import {BrandDetails} from '../BrandDetails';
import {MobileDrawer} from '../MobileDrawer';

import styles from './ExpansionBlock.css';

export function ShopPromiseExpansionBlock({
  showLogo,
  isLoading,
}: {
  isLoading: boolean;
  showLogo: boolean;
}) {
  const {zipFormVisible, mainButtonRef} = useContext(AppState);
  const isMobile = isMobileDevice();

  const onClose = useCallback(() => {
    zipFormVisible.value = false;
    mainButtonRef.current?.focus();
  }, [zipFormVisible, mainButtonRef]);

  const desktopMarkup = (
    <>
      <Line type={UiLineType.MergedColumns}>
        <div
          className={[
            styles.expansionPanel,
            zipFormVisible.value ? '' : styles.Collapsed,
          ].join(' ')}
          aria-expanded={zipFormVisible.value.toString()}
          aria-hidden={(!zipFormVisible.value).toString()}
          style={{visibility: zipFormVisible.value ? '' : 'hidden'}}
        >
          <div className={styles.desktopZipFormWrapper}>
            <ZipInputForm isLoading={isLoading} />
          </div>
          {showLogo && (
            <div className={styles.brandDetails}>
              <BrandDetails />
            </div>
          )}
        </div>
      </Line>
    </>
  );

  const mobileMarkup = (
    <MobileDrawer isOpen={zipFormVisible.value} onClose={onClose}>
      <div className={styles.mobileGenericMarkupWrapper}>
        <ZipInputForm isLoading={isLoading} focusOnMount={!showLogo} />
        {showLogo && <BrandDetails />}
      </div>
    </MobileDrawer>
  );

  return isMobile ? mobileMarkup : desktopMarkup;
}
